import {WorkspaceView} from "@src/pages/settings/workspace-view";
import {createFileRoute, useParams} from "@tanstack/react-router";
import {useWorkspace} from "@zeg/instant/w/useSettings";
import {TWorkspace} from "@zeg/instant/types";

export const Route = createFileRoute(
  "/_auth/_settings-layout/$workspaceSlug/settings/workspace"
)({component: RouteComponent});

function RouteComponent() {
  const {workspaceSlug} = useParams({
    from: "/_auth/_settings-layout/$workspaceSlug/settings/workspace",
  });
  const {data, isLoading, error} = useWorkspace(workspaceSlug as string);
  const workspace = data?.workspaces[0] as TWorkspace;
  return (
    <WorkspaceView
      workspace={workspace}
      isLoading={isLoading}
      error={error as Error}
    />
  );
}
